import { Button, Icon } from '../../../atoms'
import React from 'react'
import TooltipPlatinum from '../tooltip'
import Image from '../../imgix-img'
import { startUpBundle, midBundle, largeBundle } from './data'

const bundles = { startup: startUpBundle, mid: midBundle, large: largeBundle }

const Bundle = ({ brand = 'money', jsonBody, variant, sys, rawName }) => {
  const { businessSize = 'startup' } = jsonBody
  return (
    <div className='Bundle'>
      <div className={`Bundle__wrapper Bundle__${businessSize}`}>
        <h3>{bundles[businessSize].title}</h3>
        <p>{bundles[businessSize].description}</p>
        <div className='Bundle__info'>
          <p className='Bundle__info__included'>Included</p>
          <div>
            <div className='Bundle__tooltip' id={`${businessSize}-bundle-tooltip-icon-id`}>
              <span>
                <Icon
                  glyph={'information-circle'}
                  size={24}
                  color={brand === 'money' ? '#fff' : '#000'}
                />
              </span>
              <p>Why we’ve chosen these</p>
            </div>
            <TooltipPlatinum
              triggerElementId={`${businessSize}-bundle-tooltip-icon-id`}
              content={bundles[businessSize].toolTipContent}
              title={bundles[businessSize].tooltipTitle}
            />
          </div>
        </div>
        <div className='Bundle__products'>
          {bundles[businessSize].products.map((bundle, key) => {
            return (
              <div key={key} className='Bundle__products__product'>
                <Image src={bundle.logo} alt='provide logo' />
                <p>{bundle.name}</p>
              </div>
            )
          })}
        </div>
      </div>
      <div className='Bundle__cta'>
        <Button
          size='md'
          variant='primary'
          withIcon={true}
          href={bundles[businessSize].link}
          dataClickTracking={{
            component_category: 'platinum-component',
            component_id: sys?.id,
            component_name: 'bundle',
            contentful_name: rawName,
            contentful_variant: variant,
            additionalProps: { text: 'Select', bundleType: businessSize },
          }}
        >
          Select
        </Button>
      </div>
    </div>
  )
}

export default Bundle
